enum ServiceAreaTypeEnum {
  MemberSet = "member-set",
  ProviderSet = "provider-set",
}

export { ServiceAreaTypeEnum };
